/* global Office console */

import { createNestablePublicClientApplication } from "@azure/msal-browser";

export  function outlookAccesToken(){
  const tokenRequest = {
    scopes: ["openid", "profile", "offline_access", "email","https://graph.microsoft.com/Mail.ReadWrite"],
  };
  return new Promise( async (resolve,reject)=>{
    // Office.onReady(async (info) => {
      // if (info.host == "Outlook") {
        
        // Initialize the public client application
      var pca = await createNestablePublicClientApplication({
          auth: {
            // clientId: "cad4e92a-d7fe-425c-85b7-750dd8332382",
            clientId: "bf572a76-43de-43b7-9b36-77ab876e16ce",
            authority: "https://login.microsoftonline.com/common",
            // redirectUri: "msalcad4e92a-d7fe-425c-85b7-750dd8332382://auth"
          },
        });

        try {
          // Office.context.roamingSettings.remove("ehAccessToken");
          // Office.context.roamingSettings.saveAsync();
          var ehAccessToken = Office.context.roamingSettings.get("ehAccessToken");
          if(ehAccessToken){

              var tokenTimeStamp = new Date(ehAccessToken.expiry).getTime();
              console.log(tokenTimeStamp);
              if(isTokenExired(tokenTimeStamp)){
                console.log('re-generate token');
                var tokenObj = await generateToken (pca,tokenRequest);
                resolve(tokenObj);
              }else{
                console.log('returned saved token');
                resolve(ehAccessToken);
              }
              
          }else{
            console.log('fresh token generated');
            var tokenObj = await generateToken (pca,tokenRequest);
            resolve(tokenObj);
          }
          
        } catch (error) {
          resolve(`Unable to acquire token silently: ${error}`);
        }
      // }
    // });
  });
}

async function generateToken (pca,tokenRequest){

    var userAccount = null;

    try {
      console.log("Trying to acquire token silently...");
      userAccount = await pca.acquireTokenSilent(tokenRequest);
      console.log("Acquired token silently.");
    } catch (error) {
      console.log(`Unable to acquire token silently: ${error}`);
    }

    //  console.log(userAccount);

    if (userAccount === null) {
      // Acquire token silent failure. Send an interactive request via popup.
      try {
        console.log("Trying to acquire token interactively...");
        userAccount = await pca.acquireTokenPopup(tokenRequest);
        console.log("Acquired token interactively.");
      } catch (popupError) {
        // Acquire token interactive failure.
        console.log(`Unable to acquire token interactively: ${popupError}`);
      }
    }

    var tokenObj = {token:userAccount.accessToken,expiry:userAccount.expiresOn};
    Office.context.roamingSettings.set("ehAccessToken", tokenObj);
    Office.context.roamingSettings.saveAsync();
    return tokenObj
}


function isTokenExired(timestamp) {
  const now = Date.now(); // current time in milliseconds
  return now > timestamp;
}

export async function insertText(text) {
  // Write text to the cursor point in the compose surface.
  try {
    Office.context.mailbox.item?.body.setSelectedDataAsync(
      text,
      { coercionType: Office.CoercionType.Text },
      (asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
          throw asyncResult.error.message;
        }
      }
    );
  } catch (error) {
    console.log("Error: " + error);
  }
}

export async function outlookNotification(message) {
  Office.context.mailbox.item.notificationMessages.addAsync("apiNotification", {
    type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
    message: message,
    icon: "icon16",
    persistent: false
  });
}

export function outlookAttachments(){

  var attachments = Office.context.mailbox.item.attachments.filter((attach) => {
      if(!attach.contentType.includes('image')){
        return attach;
      }
  })

  return attachments;
}

export function outlookMessage(){
  return new Promise((resolve,reject)=>{
    Office.context.mailbox.item.body.getAsync("text", function (result) {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value)
      } else {
        reject(result.error.message);
      }
    });
  });
}